import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) {
    return (
      <div className="min-h-[60vh] grid place-items-center">
        <div className="font-mystic text-rose-400 text-lg animate-pulse">Summoning the dawn…</div>
      </div>
    );
  }
  if (!user || user === false) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
